import { createSelector } from 'reselect';
import get from 'app/common/lib/get';


const makeIsSubNotPaid = () => createSelector(
  [
    (state, props) => {
      if (props.sub) {
        return props.sub;
      }
      if (props.subId) {
        return get(state, ['apps', 'subs', props.subId], {});
      }
      return {};
    },
  ],
  (sub) => {
    const currTariff = { ...sub.tariff, ...sub.modified };
    return (
      !sub.test_days_left
      && ['lk', 'mobile', 'email', 'sms'].reduce((acc, curr) => (
        acc || (currTariff[`${curr}_enabled`] ? !sub[`${curr}_paid`] : false)
      ), false)
    );
  }
);

export default makeIsSubNotPaid;
